import React, {useEffect, useState} from "react";
import {Button, Col, Row, Skeleton} from "antd";
import {NavLink} from "react-router-dom";
import {PATH} from "../../../config";
import {useSelector} from "react-redux";
import {selectUser} from "../../../redux/features/userSlice";
import Lands from "./assets/Lands";
import Metahuts from "./assets/Metahuts";
import Avatars from "./assets/Avatars";

const Assets = () => {

    return (
        <div className="assets">
            <span className="block font-bold mb-10 meta-card-header">Assets</span>
            <Row gutter={44} className="assets-row">
                <Metahuts />
                <Lands />
                <Avatars />
            </Row>
        </div>
    )
}

export default Assets;